
const Definition = {

    id: "espart",
    plan_level: 2,
    name: "Espart",
    path: "team/espart/components/Landing",
    preview_image: "https://img.freepik.com/free-vector/abstract-red-black-background_23-2148453357.jpg",
    colors: {
        background: "#ffffff",
        background_alt: "#f2f2f2",
        surface_dark: "#000000",
        surface_dark_alt: "#262626",
        surface_dark_panel: "#272222",
        header_background: "#000000",
        text: "#000000",
        text_inverse: "#ffffff",
        text_muted: "#998888",
        primary: "#ED2025",
        primary_dark: "#E11217",
        on_primary: "#ffffff",
        success: "#22C55E",
        danger: "#ED2025"
    }

};

export default Definition;
